import request from '@/utils/request'

// 查询订单支付项分页
export function pageOrderPaymentItem(query) {
  return request({
    url: '/order/order-payment-item/page',
    method: 'get',
    params: query
  })
}

// 查询订单支付项详情
export function getOrderPaymentItem(data) {
  return request({
    url: '/order/order-payment-item/detail',
    method: 'get',
    params: data
  })
}

// 新增订单支付项
export function addOrderPaymentItem(data) {
  return request({
    url: '/order/order-payment-item/add',
    method: 'post',
    data: data
  })
}

// 修改订单支付项
export function updateOrderPaymentItem(data) {
  return request({
    url: '/order/order-payment-item/edit',
    method: 'post',
    data: data
  })
}

// 删除订单支付项
export function delOrderPaymentItem(data) {
  return request({
    url: '/order/order-payment-item/delete',
    method: 'post',
    data: data
  })
}
